<template>
  <v-form @keyup.enter.native="signIn" v-model="isFormValid">
    <v-alert :value="!!error" type="error" class="mb-3 pa-3">
      {{ error }}
    </v-alert>
    <v-text-field
      type="text"
      outlined
      persistent-placeholder
      v-model="form.username"
      autocomplete="username"
      :label="$t('user.label.username')"
      color="secondary"
      :rules="[v => !!v || ' ']"
    />
    <v-text-field
      id="password"
      type="password"
      outlined
      persistent-placeholder
      autocomplete="current-password"
      v-model="form.password"
      :label="$t('user.label.password')"
      color="secondary"
      :rules="[v => !!v || ' ']"
    />
    <v-btn
      :disabled="!isFormValid"
      ref="loginBtn"
      :loading="loading"
      min-width="100%"
      color="primary onPrimary--text"
      class="mt-3"
      @click="signIn"
      v-t="'auth.signIn'"
    />
  </v-form>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import apolloClient from "@/apollo";
import gql from "graphql-tag";

const AUTH_MUTATION = gql`
  mutation auth($username: String!, $password: String!) {
    auth(username: $username, password: $password) {
      token
      refreshToken {
        id
        expiryDate
        sessionId
      }
      mustChangePassword
    }
  }
`;

export default {
  name: "LoginFormInvira",
  data: () => ({
    loading: false,
    error: null,
    form: { username: "", password: "" },
    isFormValid: false,
  }),
  created() {
    if (this.isAuth) this.$router.push({ name: "home" });
  },
  computed: {
    ...mapState({ me: (state) => state.user.me }),
    ...mapGetters(["isAuth"]),
    getRedirectParam() {
      return this.$route.query.redirect;
    },
  },
  methods: {
    b64EncodeUnicode(str) {
      return btoa(
        encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1) =>
          String.fromCharCode("0x" + p1)
        )
      );
    },
    signIn() {
      this.loading = true;
      this.error = null;
      apolloClient
        .mutate({
          mutation: AUTH_MUTATION,
          variables: {
            username: this.form.username,
            password: this.b64EncodeUnicode(this.form.password),
          },
        })
        .then((response) => {
          const auth = response.data.auth;
          this.$store.commit("setAccessToken", auth.token);
          this.$store.commit("setRefreshToken", auth.refreshToken);
          return this.$store.dispatch("fetchMe")
            .then(() => this.$store.dispatch("fetchEffectivePermissions").catch(() => {}))
            .then(() => {
              if (auth.mustChangePassword) {
                this.$router.push({ name: "password" });
              } else if (this.getRedirectParam) {
                this.$router.push(this.getRedirectParam);
              } else {
                this.$router.push({ name: "home" }).catch(() => {});
              }
            });
        })
        .catch((err) => {
          const msg =
            err.graphQLErrors?.[0]?.extensions?.code === "UNAUTHENTICATED" &&
            err.message?.includes("BadCredentials")
              ? "auth.badCredentials"
              : err.message || "auth.badCredentials";
          this.error = this.$t(msg);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
